$(document).ready(function () {
  $(".kcoc-gallery").each(function () {
    var $gallery = $(this);
    var $main = $gallery.find(".kcoc-gallery__main");
    var $thumbs = $gallery.find(".kcoc-gallery__thumb");

    $main.slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      dots: false,
      infinite: true,
      prevArrow: $gallery.find(".kcoc-gallery__arrow--prev"),
      nextArrow: $gallery.find(".kcoc-gallery__arrow--next")
    });

    $main.on("beforeChange", function (event, slick, current, next) {
      $thumbs.removeClass("is-active");
      $thumbs.eq(next).addClass("is-active");
    });

    $thumbs.on("click", function () {
      $main.slick("slickGoTo", $(this).data("index"));
    });
  });

  $(".kcoc-offer").on("click", function () {
    var $offer = $(this);
    $offer.closest(".kcoc-offers").find(".kcoc-offer").removeClass("is-active");
    $offer.addClass("is-active");
    $offer.find(".kcoc-offer__input").prop("checked", true);
  });

  $(".kcoc-acc__head").on("click", function () {
    var $acc = $(this).closest(".kcoc-acc");
    $acc.find(".kcoc-acc__body").stop(true, true).slideToggle(200, function () {
      $acc.toggleClass("is-open");
      $(this).css("display", "");
    });
  });

  $(".kcoc-ugc__card").on("click", function () {
    var $card = $(this);
    var video = $card.find("video")[0];
    if (video.paused) {
      $(".kcoc-ugc__card.is-playing").not($card).each(function () {
        $(this).find("video")[0].pause();
        $(this).removeClass("is-playing");
      });
      video.muted = false;
      video.play();
      $card.addClass("is-playing");
    } else {
      video.pause();
      $card.removeClass("is-playing");
    }
    $card.find(".kcoc-ugc__mute").toggleClass("is-unmuted", !video.muted);
  });

  $(".kcoc-ugc__mute").on("click", function (e) {
    e.stopPropagation();
    var $card = $(this).closest(".kcoc-ugc__card");
    var video = $card.find("video")[0];
    video.muted = !video.muted;
    $(this).toggleClass("is-unmuted", !video.muted);
  });

  $(".kcoc-delivery__date").each(function () {
    var days = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
    var date = new Date();
    date.setDate(date.getDate() + parseInt($(this).data("days"), 10));
    var day = date.getDate();
    var suffix = "th";
    if (day % 10 === 1 && day !== 11) suffix = "st";
    if (day % 10 === 2 && day !== 12) suffix = "nd";
    if (day % 10 === 3 && day !== 13) suffix = "rd";
    $(this).text(days[date.getDay()] + ", " + day + suffix);
  });

  var $rings = $(".kcoc-stat__ring");

  $rings.each(function () {
    this.style.setProperty("--kcoc-percent", "0%");
    $(this).find(".kcoc-stat__value").text("0%");
  });

  function kcocCountRings() {
    $rings.each(function () {
      var ring = this;
      var $ring = $(ring);
      if ($ring.data("done") || !$ring.is(":visible")) return;
      if ($(window).scrollTop() + $(window).height() < $ring.offset().top + $ring.outerHeight() / 2) return;
      $ring.data("done", true);
      var target = parseInt($ring.data("percent"), 10);
      $({ value: 0 }).animate({ value: target }, {
        duration: 1600,
        easing: "swing",
        step: function (now) {
          ring.style.setProperty("--kcoc-percent", now + "%");
          $ring.find(".kcoc-stat__value").text(Math.round(now) + "%");
        },
        complete: function () {
          ring.style.setProperty("--kcoc-percent", target + "%");
          $ring.find(".kcoc-stat__value").text(target + "%");
        }
      });
    });
  }

  $(window).on("scroll resize", kcocCountRings);
  kcocCountRings();

  $(".kcoc-cta").on("click", function (e) {
    var href = $(this).attr("href");
    if (href.charAt(0) !== "#" || !$(href).length) return;
    e.preventDefault();
    $("html, body").animate({ scrollTop: $(href).offset().top }, 600);
  });

  $(".kcoc-why__head").on("click", function () {
    var $why = $(this).closest(".kcoc-why");
    $why.find(".kcoc-why__body").stop(true, true).slideToggle(200, function () {
      $why.toggleClass("is-open");
      $(this).css("display", "");
    });
  });

  $(".kcoc-ingr__more").on("click", function () {
    var $card = $(this).closest(".kcoc-ingr");
    $card.find(".kcoc-ingr__details").stop(true, true).slideToggle(200, function () {
      $card.toggleClass("is-open");
      $(this).css("display", "");
    });
  });

  $(".kcoc-formula__track").on("scroll", function () {
    var $track = $(this);
    var step = $track.find(".kcoc-ingr").outerWidth() + 8;
    var index = Math.round($track.scrollLeft() / step);
    var $dots = $track.siblings(".kcoc-formula__dots").find(".kcoc-formula__dot");
    $dots.removeClass("is-active");
    $dots.eq(index).addClass("is-active");
  });

  $(".kcoc-formula__dot").on("click", function () {
    var $track = $(this).closest(".kcoc-formula__row").find(".kcoc-formula__track");
    var step = $track.find(".kcoc-ingr").outerWidth() + 8;
    $track.animate({ scrollLeft: $(this).data("index") * step }, 300);
  });

  function kcocStepsLine() {
    $(".kcoc-steps").each(function () {
      var $steps = $(this);
      var $items = $steps.find(".kcoc-step");
      if (!$items.length) return;
      var box = $steps.offset();
      var first = $items.first();
      var last = $items.last();
      if ($(window).width() > 768) {
        var x1 = first.offset().left - box.left + first.outerWidth() / 2;
        var x2 = last.offset().left - box.left + last.outerWidth() / 2;
        $steps.find(".kcoc-steps__line").css({ top: 0, left: x1 - 1, width: x2 - x1 + 2, height: 2 });
      } else {
        var y1 = first.offset().top - box.top + first.outerHeight() / 2;
        var y2 = last.offset().top - box.top + last.outerHeight() / 2;
        $steps.find(".kcoc-steps__line").css({ top: y1 - 1, left: 3, width: 2, height: y2 - y1 + 2 });
      }
    });
  }

  function kcocStepsDraw() {
    var reach = $(window).scrollTop() + $(window).height() * 0.6;
    $(".kcoc-steps").each(function () {
      var $steps = $(this);
      var $line = $steps.find(".kcoc-steps__line");
      if ($(window).width() > 768) {
        $line.css("transform", "");
        $steps.find(".kcoc-step").removeClass("is-on");
        if (!$steps.hasClass("is-drawn") && $(window).scrollTop() + $(window).height() * 0.75 > $steps.offset().top) {
          $steps.addClass("is-drawn");
        }
        return;
      }
      $steps.removeClass("is-drawn");
      var top = $line.offset().top;
      var height = $line.outerHeight();
      var progress = height ? Math.min(Math.max((reach - top) / height, 0), 1) : 0;
      $line.css("transform", "scaleY(" + progress + ")");
      $steps.find(".kcoc-step").each(function () {
        var center = $(this).offset().top + $(this).outerHeight() / 2;
        $(this).toggleClass("is-on", reach >= center - 1);
      });
    });
  }

  kcocStepsLine();
  kcocStepsDraw();
  $(window).on("load resize", function () {
    kcocStepsLine();
    kcocStepsDraw();
  });
  $(window).on("scroll", kcocStepsDraw);

  $(".kcoc-expert").on("click", function () {
    $("#" + $(this).data("target")).addClass("is-open");
    $("html").css("overflow", "hidden");
  });

  $(".kcoc-expert-modal, .kcoc-expert-modal__close").on("click", function () {
    $(".kcoc-expert-modal").removeClass("is-open");
    $("html").css("overflow", "");
  });

  $(".kcoc-expert-modal__box").on("click", function (e) {
    if (!$(e.target).hasClass("kcoc-expert-modal__close")) e.stopPropagation();
  });

  $(".kcoc-faq__q").on("click", function () {
    var $item = $(this).closest(".kcoc-faq__item");
    $item.find(".kcoc-faq__a").stop(true, true).slideToggle(200, function () {
      $item.toggleClass("is-open");
      $(this).css("display", "");
    });
  });

  $(".kcoc-atc").on("click", function () {
    var $hero = $(this).closest(".kcoc-hero");
    var champsId = $hero.find(".kcoc-offer.is-active .kcoc-offer__input").data("champs-id");
    if (!champsId) return;
    var params = new URLSearchParams();
    params.set("products", champsId + ":1");
    new URLSearchParams(window.location.search).forEach(function (value, key) {
      var k = key.toLowerCase();
      if ((k === "utm" || k.indexOf("utm_") === 0) && !params.has(key)) params.append(key, value);
    });
    window.location.href = $(this).data("checkout-url") + "?" + params.toString().replace("%3A", ":");
  });
});
